import {Component, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {ProjectDTO} from '../../dto/project';
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {deleteProject} from '../../service/project.actions';
import {selectAllProjects, selectError, selectLoading} from '../../service/project.selectors';
import {RouterLink} from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import {ConfirmDialogComponent} from '../../../../utils/components/confirm-dialog/confirm-dialog.component';
import {ProjectCreateDialogComponent} from '../project-create-dialog/project-create-dialog.component';
import {LoadingCardComponent} from '../../../../utils/components/loading-card/loading-card.component';
import {EmptyStateComponent} from '../../../../utils/components/empty-state/empty-state.component';
import {HeaderComponent} from '../../../../utils/components/header/header.component';

@Component({
  selector: 'app-project-list',
  imports: [
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatToolbarModule,
    RouterLink,
    MatMenuModule,
    LoadingCardComponent,
    EmptyStateComponent,
    HeaderComponent
  ],
  templateUrl: './project-list.component.html',
  styleUrl: './project-list.component.scss'
})
export class ProjectListComponent {
  private readonly store: Store = inject(Store);
  private readonly dialog: MatDialog = inject(MatDialog);

  displayedColumns: string[] = ['name', 'topic', 'actions'];
  projects = this.store.selectSignal(selectAllProjects);
  error = this.store.selectSignal(selectError);
  loading = this.store.selectSignal(selectLoading);


  createProject(): void {
    this.dialog.open(ProjectCreateDialogComponent, {autoFocus: false});
  }

  deleteProject(project: ProjectDTO): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      data: {
        title: `Delete Project: ${project.name}?`,
        message: `Are you sure you want to delete the project ${project.topic}?`,
        confirmButtonText: 'Delete',
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.store.dispatch(deleteProject({id: project.id}));
      }
    });
  }


}
